export default {
  toggleSidebar () {
    let icon = document.getElementsByClassName('hamburger')[0]
    document.body.classList.toggle('sidebar-open')
    icon.classList.toggle('is-active')
  },

  addClass (el, className) {
    if (el.classList) el.classList.add(className)
    else el.className += ' ' + className
  },

  hasClass (el, className) {
    const hasClass = el.classList
      ? el.classList.contains(className)
      : new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className)

    return hasClass
  },

  reset (prefix) {
    let regx = new RegExp('\\b' + prefix + '(.*)?\\b', 'g')
    document.body.className = document.body.className.replace(regx, '')
  },

  setLayout (layoutName) {
    this.reset('layout-')
    document.body.classList.add('layout-' + layoutName)
  },

  setSkin (skinName) {
    this.reset('skin-')
    document.body.classList.add('skin-' + skinName)
  },

  setLogo (logoSrc) {
    document.getElementById('logo-desk').src = logoSrc
  },

  truncateToTwoDecimals: (value) => {
    const factor = Math.pow(10, 2)
    // Use toFixed to avoid FP drift (e.g., 9.5299999) then floor to truncate
    return Math.floor((value * factor).toFixed(2)) / factor
  },

  // Round to a given precision using half-up strategy
  roundToPrecision: (value, precision = 2) => {
    const factor = Math.pow(10, precision)
    return Math.round((Number(value) + Number.EPSILON) * factor) / factor
  },

  formatMoney (amount, currency = 0) {
    if (!currency) {
      currency = {
        precision: 2,
        thousand_separator: ',',
        decimal_separator: '.',
        symbol: '$'
      }
    }

    let { precision, decimal_separator, thousand_separator, symbol } = currency

    // Function to round a number to a specific precision (half-up)
    const roundToPrecision = (value, precision) => {
      const factor = Math.pow(10, precision)
      return Math.round((Number(value) + Number.EPSILON) * factor) / factor
    }

    try {
      precision = Math.abs(precision)
      precision = isNaN(precision) ? 2 : precision
      const negativeSign = amount < 0 ? '-' : ''
      const absoluteAmount = Math.abs(Number(amount) || 0)
      const roundedAmount = roundToPrecision(absoluteAmount, precision)
      let i = parseInt(roundedAmount).toString() // Integer part
      let j = (i.length > 3) ? i.length % 3 : 0

      // Extract the fractional part from rounded value
      const fractionalPart = roundedAmount.toFixed(precision).split('.')[1] || ''
      const roundedFractionalPart = fractionalPart.padEnd(precision, '0').slice(0, precision)

      let moneySymbol = `<span style="font-family: sans-serif">${symbol}</span>`
      return moneySymbol + ' ' +
        negativeSign +
        (j ? i.substr(0, j) + thousand_separator : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand_separator) +
        (precision ? decimal_separator + roundedFractionalPart : '')
      } catch (e) {
      console.log(e)
    }
  },

  formatGraphMoney (amount, currency = 0) {
    if (!currency) {
      currency = {
        precision: 2,
        thousand_separator: ',',
        decimal_separator: '.',
        symbol: '$'
      }
    }

    let { precision, decimal_separator, thousand_separator, symbol } = currency

    const roundToPrecision = (value, precision) => {
      const factor = Math.pow(10, precision)
      return Math.round((Number(value) + Number.EPSILON) * factor) / factor
    }

    try {
      precision = Math.abs(precision)
      precision = isNaN(precision) ? 2 : precision
      const negativeSign = amount < 0 ? '-' : ''
      const absoluteAmount = Math.abs(Number(amount) || 0)
      const roundedAmount = roundToPrecision(absoluteAmount, precision)
      let i = parseInt(roundedAmount).toString() // Integer part
      let j = (i.length > 3) ? i.length % 3 : 0

      const fractionalPart = roundedAmount.toFixed(precision).split('.')[1] || ''
      const roundedFractionalPart = fractionalPart.padEnd(precision, '0').slice(0, precision)

      let moneySymbol = `${symbol}`

      return moneySymbol + ' ' +
        negativeSign +
        (j ? i.substr(0, j) + thousand_separator : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand_separator) +
        (precision ? decimal_separator + roundedFractionalPart : '')
      } catch (e) {
      console.log(e)
    }
  },

  checkValidUrl (url) {
    let pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ) // fragment locator

    return !!pattern.test(url)
  }
}
